import { MilestoneStatusCode } from '@bechtel/types';
export const fitupMilestoneStats: { status: MilestoneStatusCode; value: number }[] = [
  {
    status: MilestoneStatusCode.REQUESTED,
    value: 0,
  },
  {
    status: MilestoneStatusCode.CLAIMED,
    value: 0,
  },
  {
    status: MilestoneStatusCode.APPROVED,
    value: 0,
  },
  {
    status: MilestoneStatusCode.REJECTED,
    value: 0,
  },
  {
    status: MilestoneStatusCode.BLOCKED,
    value: 0,
  },
];

export const installMilestoneStats: { status: MilestoneStatusCode; value: number }[] = [
  {
    status: MilestoneStatusCode.UNPLANNED,
    value: 0,
  },
  {
    status: MilestoneStatusCode.PLANNED,
    value: 0,
  },
  {
    status: MilestoneStatusCode.CLAIMED,
    value: 0,
  },
  {
    status: MilestoneStatusCode.APPROVED,
    value: 0,
  },
  {
    status: MilestoneStatusCode.REJECTED,
    value: 0,
  },
  {
    status: MilestoneStatusCode.BLOCKED,
    value: 0,
  },
];
